import { CloneTableToolbar } from '@/features/shared/components/cloneTable/CloneTableToolbar';
import {
  cloneExecutionColumnOptions,
  cloneExecutionDefaultColumnVisibilityModel,
  cloneExecutionDefaultSortDirection,
  cloneExecutionDefaultSortKey,
  cloneExecutionSortOptions,
  type CloneExecutionSortDirection,
  type CloneExecutionSortKey,
  cloneExecutionStatusOptions,
} from '@/features/tests/pages/testExecutionsPageCloneConfig';
import type { CloneDateQuickFilter } from '@/features/shared/hooks/useCloneDateWindow';
import type { GridColumnVisibilityModel } from '@/ui/primitives';
import type { TestExecutionStatus } from '@flowqa/shared';
import type { Dayjs } from 'dayjs';
import type { ReactElement } from 'react';

type TestExecutionsCloneToolbarProps = {
  title?: string;
  onDebouncedCloneSearchChange: (value: string) => void;
  columnVisibilityModel: GridColumnVisibilityModel;
  onColumnVisibilityModelChange: (nextModel: GridColumnVisibilityModel) => void;
  sortKey: CloneExecutionSortKey;
  sortDirection: CloneExecutionSortDirection;
  onSortChange: (
    sortKey: CloneExecutionSortKey,
    sortDirection: CloneExecutionSortDirection,
  ) => void;
  filterStatuses: TestExecutionStatus[];
  onFilterStatusesChange: (next: TestExecutionStatus[]) => void;
  filterSuites?: string[];
  onFilterSuitesChange?: (next: string[]) => void;
  suiteOptions?: Array<{ value: string; label: string }>;
  filterTags: string[];
  onFilterTagsChange: (next: string[]) => void;
  dateQuickFilter: CloneDateQuickFilter;
  onDateQuickFilterChange: (next: CloneDateQuickFilter) => void;
  fromDate: Dayjs | null;
  toDate: Dayjs | null;
  onFromDateChange: (next: Dayjs | null) => void;
  onToDateChange: (next: Dayjs | null) => void;
  availableTags: string[];
};

export const TestExecutionsCloneToolbar = (
  props: TestExecutionsCloneToolbarProps,
): ReactElement => (
  <CloneTableToolbar<CloneExecutionSortKey, TestExecutionStatus>
    title="Executions"
    searchAriaLabel="Search test executions"
    defaultColumnVisibilityModel={cloneExecutionDefaultColumnVisibilityModel}
    columnOptions={cloneExecutionColumnOptions}
    defaultSortKey={cloneExecutionDefaultSortKey}
    defaultSortDirection={cloneExecutionDefaultSortDirection}
    sortOptions={cloneExecutionSortOptions}
    statusOptions={cloneExecutionStatusOptions}
    includeLatestQuickFilter
    statusFilterLabel="Status"
    {...props}
  />
);
